/**
 * Created by amitt
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/usersSetConcurrencyDialogView.tmpl");
    var UsersSetConcurrencyDialogInnerView = require("user-management-views/users/UsersSetConcurrencyDialogInnerView");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var UserModel = require("models/entities/UserModel");

    var UsersSetConcurrencyDialogView = {};


    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        UsersSetConcurrencyDialogView = Marionette.Layout.extend({

            className: "set-concurrency-container",
            template: template,
            ui: {
                maxChats: ".set-concurrency-max-chats",
                maxAsyncChats: ".set-concurrency-max-async-chats-container",
                cancelButton: ".set-concurrency-cancel-btn",
                saveButton: ".set-concurrency-save-btn",
            },
            uiComponents: {
                maxChatsInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.maxChats",
                        permutation: InputField.Permutation.E,
                        placeholder: LE.translator.translate("LEUserManagement.userList.setConcurrency.maxChats.placeholder"),
                        inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
                        range: {min: 0, max: 9},
                        zIndexBubble: 10001 // todo how to do this properly? can I get 'this' z-index and use it? I know that dialog z-index is 10,000
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSaveClick"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancelCLick"
                    }
                }
            },

            initialize: function (options) {
                options = options || {};
                this.selectedUsers = options.selectedUsers;
                this.modelValidators = UserModel.MODEL_VALIDATORS;
                this.maxConversationsSettings = options.maxConversationsSettings;
                this.messagingEnabled = options.messagingEnabled;
                this._bindEvents();
            },

            onRender: function () {
                if (this.messagingEnabled) {
                    this.innerView = new UsersSetConcurrencyDialogInnerView({
                        modelValidators: this.modelValidators,
                        maxConversationsSettings: this.maxConversationsSettings,
                        el: this.ui.maxAsyncChats
                    });
                    this.listenTo(this.innerView, "concurrencyInnerView:maxAsyncChatsChanged", this._onMaxAsyncChatsChanged);
                    this.innerView.render();
                } else {
                    this.ui.maxAsyncChats.addClass("hide");
                }
                this.uiComponents.maxChatsInput.setFocus(true);
            },

            _bindEvents: function () {
                this.listenTo(this, "dialog:closeButtonClick", this._onCloseClick);
            },

            customTemplateHelpers: function () {
                var subtitleMessagingPart;
                if (this.messagingEnabled) {
                    subtitleMessagingPart = "LEUserManagement.userList.setConcurrency.subtitle.part.messaging";
                } else {
                    subtitleMessagingPart = {key: "", isTranslate: false};
                }
                var emphasizedUsersLength = "<strong>" + this.selectedUsers.length + "</strong>";
                return {
                    setConcurrencySubtitle: LE.translator.translate({
                        key: "LEUserManagement.userList.setConcurrency.subtitle",
                        args: [
                            subtitleMessagingPart,
                            {key: emphasizedUsersLength, isTranslate: false}
                        ]
                    })
                };
            },

            _onMaxAsyncChatsChanged: function (value) {
                LEUserManagement.logger.debug("max async chats input changed to " + value, "UsersSetConcurrencyDialogView:_onMaxAsyncChatsChanged");
                this.maxAsyncChats = value;
            },

            _onSaveClick: function () {
                function _parse(value) {
                    var num = parseInt(value, 10);
                    return isNaN(num) ? void 0 : num;
                }

                var maxChats = _parse(this.uiComponents.maxChatsInput.getValue());
                // null is allowed when updating the account-level settings
                var maxAsyncChats = this.maxAsyncChats === null ? null : _parse(this.maxAsyncChats);

                LEUserManagement.logger.debug("changes were made to set concurrency", "UsersSetConcurrencyDialogView:_onSaveClick");
                this.trigger("dialogInnerView:onSaveClick", {
                    selectedUsers: this.selectedUsers,
                    maxChats: maxChats,
                    maxAsyncChats: maxAsyncChats
                });
            },

            _onCancelCLick: function () {
                LEUserManagement.logger.debug("dialog innerView cancel button clicked", "UsersSetConcurrencyDialogView:_onCancelCLick");
                this._closeDialog();
            },

            _onCloseClick: function () {
                LEUserManagement.logger.debug("dialog close button clicked", "UsersSetConcurrencyDialogView:_onCloseClick");
                this._closeDialog();
            },

            _closeDialog: function () {
                this.trigger("dialogInnerView:closeDialog");
            }
        });
    });

    return UsersSetConcurrencyDialogView;
});
